<template>
  <ul class="tabs" :style="cssVars">
    <li
      v-for="(tabData, i) in data"
      :key="tabData.key"
      :class="{ active: currentIndex === i }"
      @click="changeIndex(i)"
    >
      {{ tabData.value }}
    </li>
  </ul>
</template>

<script>
export default {
  name: 'TabsList',
  data() {
    return {
      currentIndex: 0,
    };
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    maxWidth: {
      type: String,
      default: "",
    },
  },
  computed: {
    cssVars() {
      return {
        "--max-width": `${parseInt(this.maxWidth, 10)}px`
      };
    },
  },
  methods: {
    changeIndex(index) {
      this.currentIndex = index;

      this.$emit("onTabChange", {
        index,
        eventData: this.data[index],
      });
    },
  },
};
</script>

<style scoped>
    .tabs {
      max-width: var(--max-width);
    }

    /*.tabs li {
        border-bottom: solid 4px $ca-review-link-color;
        cursor: pointer;
        opacity: 0.5;
        padding-bottom: 12px;
        text-transform: uppercase;
        width: 100%;
    }

    .tabs li.active {
        border-bottom: solid 4px $ca-review-link-color;
        opacity: 1;
    }

    @media only screen and (max-width: 640px) {
        .tabs {
            padding: 0;
        }
    }
    @media (max-width: 480px) {
        .tabs {
            font-size: 14px;
        }
        .tabs li{
          height:3em;
        }
    }*/
</style>